
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

interface LegalPortalCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
  estimatedReadTime: string;
  accentColor: string;
  index: number;
}

export const LegalPortalCard: React.FC<LegalPortalCardProps> = ({
  title,
  description,
  icon: Icon,
  href,
  estimatedReadTime,
  accentColor,
  index
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
    >
      <Link to={href}>
        <Card className="group h-full transition-all duration-300 hover:shadow-xl hover:scale-[1.02] border-2 hover:border-primary/50 cursor-pointer overflow-hidden relative">
          <div 
            className="absolute top-0 left-0 right-0 h-1 transition-all duration-300 group-hover:h-2"
            style={{ backgroundColor: accentColor }}
          />
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <div 
                className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                style={{ backgroundColor: `${accentColor}20` }}
              >
                <Icon className="w-6 h-6" style={{ color: accentColor }} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold mb-2 group-hover:text-primary transition-colors">
                  {title}
                </h3>
                <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                  {description}
                </p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {estimatedReadTime}
                  </span>
                  <span className="text-primary group-hover:translate-x-1 transition-transform inline-block">
                    →
                  </span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};
